export const combineParts = parts => parts.filter(Boolean).join(", ");
export const formatSSN = ssn => `${ssn.slice(0, 3)}-${ssn.slice(3, 5)}-${ssn.slice(5)}`;
export const formatEIN = ein => `${ein.slice(0, 2)}-${ein.slice(2)}`;
export const formatPhoneNumber = num => `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(6)}`;
